import { useTranslation } from 'react-i18next';
import { Form } from 'bonfire-kindling';

const SavedSearchSettingsUpsertName = () => {
  const { t } = useTranslation();

  return (
    <Form.TextField
      label={t('settings.saved_search.edit_or_create.name_title')}
      name="name"
      margin="dense"
      maxLength={255}
      fullWidth
      required
    />
  );
};

export default SavedSearchSettingsUpsertName;
